<template>
  <div :class="{'mod-itinerary': true, 'mod-itinerary-transfer': isTransfer, 'isLC': itinerary.itineraryType === 'LC', 'isJJC': isJJC}">
    <template v-if="!isTransfer">
      <div class="cell-header clearfix">
        <div class="info-wrapper">
          <div
            class="flight clearfix"
            v-for="(flight, index) in itinerary.orgDsts"
            :key="flight.flightNo"
          >
            <div class="orgdst departure">
              <div class="time">
                <a-popover placement="bottom" overlayClassName="flight-time-popover">
                  <template slot="content">
                    <l8-icon type="icon-shijianlishijilujishizhongbiaoxianxing"></l8-icon>
                    此为当地时间
                  </template>
                  <span>{{ flight.departureTime | getTime }}</span>
                </a-popover>
              </div>
              <div class="airport">{{ flight.departureAirPortName }}{{ flight.departureTerminal }}</div>
            </div>
            <div class="more-info">
              <div class="wrapper">
                <div class="type" v-if="flight.stopQuantity">经停: {{ flight.stopCitys | stopCity }}</div>
                <div class="type" v-else>直飞</div>
                <div class="duration" v-if="!ifInternational?.()">{{ flight | duration }}</div>
                <div class="duration" v-else >{{ flight.duration | transferDurationSimple }}</div>
              </div>
            </div>
            <div class="orgdst arrival">
              <div class="time">
                <a-popover placement="bottom" overlayClassName="flight-time-popover">
                  <template slot="content">
                    <l8-icon type="icon-shijianlishijilujishizhongbiaoxianxing"></l8-icon>
                    此为当地时间
                  </template>
                  <span>{{ flight.arrivalTime | getTime }}</span>
                  <span class="gt-day">{{ itinerary.orgDsts[index] | gtDay }}</span>
                </a-popover>
              </div>
              <div class="airport">{{ flight.arrivalAirPortName }}{{ flight.arrivalTerminal }}</div>
            </div>
            <div class="flight-info flex-hl-vc flex-hw">
              <span :class="['airline-logo-pure', 'logo', !setAirlineImage(flight.airlineCode) && `logo-${flight.airlineCode.toLocaleLowerCase()}`]">
                <img v-if="setAirlineImage(flight.airlineCode)" :src="setAirlineImage(flight.airlineCode)" />
              </span>
              <span class="airline-name">{{ flight.belongGroup ? `${flight.belongGroup} | ` : ''}}{{ flight.airlineName }}</span>
              <span class="flight-no">{{ flight.flightNo }}</span>
              <!-- <a-popover v-if="exitAircraftImage(flight.aircraftCode)" placement="bottom" overlayClassName="aircraft-image-popover">
                <template slot="content">
                  <img :src="flight.aircraftCode | aircraftImage" :alt="`机型：${flight.aircraftCode}`">
                </template>
                <span class="aircraft has-image">{{ flight.aircraftCode }}</span>
              </a-popover> -->
              <span class="aircraft">{{ flight.aircraftCode }}</span>
              <template v-if="handleShowBoutiqueAirlineByCms(flight)">
                <img class="boutique-airline-icon" :src="handleShowBoutiqueAirlineByCms(flight)?.labelImg">
              </template>
            </div>
          </div>
        </div>
        <div class="type-wrapper flight-info-wrap float-right clearfix">
          <template v-for="(cabin, cabinIndex) in itinerary.cabins">
            <div v-show="!cabin.isHide" :key="cabin.cabinLevel" class="cabin-item float-left"  :class="['cabin-'+ cabin.cabinLevel, {'active': cabin.checked, 'disabled': cabin.disabled, 'buss': isBussCabin(cabin.cabinLevel), 'ecom': isEcomCabin(cabin.cabinLevel)}]" @click="onCabinChange($event, cabin.cabinLevel, cabinIndex, true)">
              <p class="cabin-type">{{cabin.cabinName}}</p>
              <a-checkbox class="cabin-choose" :value="cabin.cabinLevel" :disabled="cabin.disabled" :checked="cabin.checked" @change="onCabinChange($event)" :ref="`cabinCheckBox-${index}`"></a-checkbox>
              <p class="ticket-price" v-if="!cabin.disabled">￥<strong class="pricetag" >{{ cabin.price ? cabin.price : getLowestPrice(cabin) }}</strong>起</p>
              <p class="ticket-price" v-else>-</p>
            </div>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="mod-itinerary-transfer-total" v-if="!openTransfer">
        <div class="cell-header clearfix">
          <div class="info-wrapper">
            <div
              class="flight clearfix"
            >
              <div class="orgdst departure">
                <div class="time">
                  <a-popover placement="bottom" overlayClassName="flight-time-popover">
                    <template slot="content">
                      <l8-icon type="icon-shijianlishijilujishizhongbiaoxianxing"></l8-icon>
                      此为当地时间
                    </template>
                    <span>{{ orgDstTotal.departureTime | getTime }}</span>
                  </a-popover>
                </div>
                <div class="airport">{{ orgDstTotal.departureAirPortName }}{{ orgDstTotal.departureTerminal }}</div>
              </div>
              <div class="more-info">
                <div class="wrapper">
                  <div class="type transfer-type" >中转{{ orgDstTotal.flightInfos?.length - 1 }}次
                    <span class="primary-color">{{ getLuggageTags(orgDstTotal) }}</span>
                  </div>
                  <div class="duration">{{ orgDstTotal | transferDurationTotal(itinerary.orgDsts) }}</div>
                </div>
              </div>
              <div class="orgdst arrival">
                <div class="time">
                  <a-popover placement="bottom" overlayClassName="flight-time-popover">
                    <template slot="content">
                      <l8-icon type="icon-shijianlishijilujishizhongbiaoxianxing"></l8-icon>
                      此为当地时间
                    </template>
                    <span>{{ orgDstTotal.arrivalTime | getTime }}</span>
                    <span class="gt-day">{{ orgDstTotal | gtDay }}</span>
                  </a-popover>
                </div>
                <div class="airport">{{ orgDstTotal.arrivalAirPortName }}{{ orgDstTotal.arrivalTerminal }}</div>
              </div>
              <div class="transfer" v-if="orgDstTotal.itineraryType === 'LC' && index === 0">
                中转时长：{{ orgDstTotal.orgDsts | transferDuration }}
              </div>
              <div class="flight-info flex-hl-vc flex-hw" :style="{ padding: `${20 / orgDstTotal.flightInfos.length}px 0`}">
                <div v-for="flightInfo in orgDstTotal.flightInfos" :key="flightInfo.flightNo">
                  <span :class="['airline-logo-pure', 'logo', !setAirlineImage(flightInfo.airlineCode) && `logo-${flightInfo.airlineCode.toLocaleLowerCase()}`]">
                    <img v-if="setAirlineImage(flightInfo.airlineCode)" :src="setAirlineImage(flightInfo.airlineCode)" />
                  </span>
                  <span class="airline-name">{{ flightInfo.belongGroup ? `${flightInfo.belongGroup} | ` : ''}}{{ flightInfo.airlineName }}</span>
                  <span class="flight-no">{{ flightInfo.flightNo }}</span>
                  <template v-if="handleShowBoutiqueAirlineByCms(flightInfo)">
                    <img class="boutique-airline-icon" :src="handleShowBoutiqueAirlineByCms(flightInfo)?.labelImg">
                  </template>
                  <!-- <a-popover v-if="exitAircraftImage(flightInfo.aircraftCode)" placement="bottom" overlayClassName="aircraft-image-popover">
                    <template slot="content">
                      <img :src="flightInfo.aircraftCode | aircraftImage" :alt="`机型：${flightInfo.aircraftCode}`">
                    </template>
                    <span class="aircraft has-image">{{ flightInfo.aircraftCode }}</span>
                  </a-popover> -->
                  <span class="aircraft">{{ flightInfo.aircraftCode }}</span>
                </div>
              </div>
            </div>
            <div class="switch-btn" @click="openTransfer = !openTransfer">
              航班详情
              <a-icon class="switch-btn-icon" :type="`${ !openTransfer ? 'down' : 'up' }-circle`"/>
            </div>
          </div>
          <div class="type-wrapper flight-info-wrap float-right clearfix">
            <template v-for="(cabin, cabinIndex) in itinerary.cabins">
              <div v-show="!cabin.isHide" :key="cabin.cabinLevel" class="cabin-item float-left"  :class="['cabin-'+ cabin.cabinLevel, {'active': cabin.checked, 'disabled': cabin.disabled, 'buss': isBussCabin(cabin.cabinLevel), 'ecom': isEcomCabin(cabin.cabinLevel)}]" @click="onCabinChange($event, cabin.cabinLevel, cabinIndex, true)">
                <p class="cabin-type">{{cabin.cabinName}}</p>
                <a-checkbox class="cabin-choose" :value="cabin.cabinLevel" :disabled="cabin.disabled" :checked="cabin.checked" @change="onCabinChange($event)" :ref="`cabinCheckBox-${index}`"></a-checkbox>
                <p class="ticket-price" v-if="!cabin.disabled">￥<strong class="pricetag" >{{ cabin.price ? cabin.price : getLowestPrice(cabin) }}</strong>起</p>
                <p class="ticket-price" v-else>-</p>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="mod-itinerary-transfer-detail" v-else>
        <div class="cell-header clearfix">
          <div class="info-wrapper">
            <div
              v-for="(flight, index) in itinerary.orgDsts"
              :key="flight.flightNo">
              <div class="flight clearfix">
                <div class="orgdst departure">
                  <div class="time">
                    <a-popover placement="bottom" overlayClassName="flight-time-popover">
                      <template slot="content">
                        <l8-icon type="icon-shijianlishijilujishizhongbiaoxianxing"></l8-icon>
                        此为当地时间
                      </template>
                      <span>{{ flight.departureTime | getTime }}</span>
                      <span class="gt-day">{{ itinerary.orgDsts[0].departureDate | gtDayForTransfer(itinerary.orgDsts[index].departureDate) }}</span>
                    </a-popover>
                  </div>
                  <div class="airport">{{ flight.departureAirPortName }}{{ flight.departureTerminal }}</div>
                  <div class="cutOffTime">
                    <template v-if="flight.cutOffTime">航班起飞前{{ flight.cutOffTime }}分钟停止办理乘机手续</template>
                    <template v-else>航班截载时间以机场信息为准</template>
                  </div>
                </div>
                <div class="more-info">
                  <div class="wrapper">
                    <div class="type" v-if="flight.stopQuantity">经停: {{ flight.stopCitys | stopCity }}</div>
                    <div class="type" v-else>直飞</div>
                    <div class="duration" v-if="!ifInternational?.()">{{ flight | duration }}</div>
                    <div class="duration" v-else >{{ flight.duration | transferDurationSimple }}</div>
                  </div>
                </div>
                <div class="orgdst arrival">
                  <div class="time">
                    <a-popover placement="bottom" overlayClassName="flight-time-popover">
                      <template slot="content">
                        <l8-icon type="icon-shijianlishijilujishizhongbiaoxianxing"></l8-icon>
                        此为当地时间
                      </template>
                      <span>{{ flight.arrivalTime | getTime }}</span>
                      <span class="gt-day">{{ itinerary.orgDsts[0].departureDate | gtDayForTransfer(itinerary.orgDsts[index].arrivalDate) }}</span>
                    </a-popover>
                  </div>
                  <div class="airport">{{ flight.arrivalAirPortName }}{{ flight.arrivalTerminal }}</div>
                </div>
                <div class="transfer" v-if="itinerary.itineraryType === 'LC' && index === 0">
                  中转时长：{{ itinerary.orgDsts | transferDuration }}
                </div>
                <div class="flight-info flex-hl-vc flex-hw">
                  <span :class="['airline-logo-pure', 'logo', !setAirlineImage(flight.airlineCode) && `logo-${flight.airlineCode.toLocaleLowerCase()}`]">
                    <img v-if="setAirlineImage(flight.airlineCode)" :src="setAirlineImage(flight.airlineCode)" />
                  </span>
                  <span class="airline-name">{{ flight.belongGroup ? `${flight.belongGroup} | ` : ''}}{{ flight.airlineName }}</span>
                  <span class="flight-no">{{ flight.flightNo }}</span>
                  <!-- <a-popover v-if="exitAircraftImage(flight.aircraftCode)" placement="bottom" overlayClassName="aircraft-image-popover">
                    <template slot="content">
                      <img :src="flight.aircraftCode | aircraftImage" :alt="`机型：${flight.aircraftCode}`">
                    </template>
                    <span class="aircraft has-image">{{ flight.aircraftCode }}</span>
                  </a-popover> -->
                  <span class="aircraft">{{ flight.aircraftCode }}</span>
                  <template v-if="handleShowBoutiqueAirlineByCms(flight)">
                    <img class="boutique-airline-icon" :src="handleShowBoutiqueAirlineByCms(flight)?.labelImg">
                  </template>
                </div>
              </div>
              <a-divider class="divider" orientation="left" v-if="flight.transferDuration">
                <div class="transferDuration">
                  <a-icon type="clock-circle" />
                  <span>中转时间：{{ flight.transferDuration | duration }} </span>
                  <span class="primary-color">{{ getLuggageTags(itinerary.orgDstTotal) }}</span>
                </div>
              </a-divider>
            </div>
            <div class="switch-btn" @click="openTransfer = !openTransfer">
              航班详情
              <a-icon class="switch-btn-icon" :type="`${ !openTransfer ? 'down' : 'up' }-circle`" />
            </div>
          </div>
          <div class="type-wrapper flight-info-wrap float-right clearfix">
            <template v-for="(cabin, cabinIndex) in itinerary.cabins">
              <div
                v-show="!cabin.isHide"
                :key="cabin.cabinLevel" class="cabin-item float-left"
                :class="[cabin.cabinLevel && 'cabin-'+ cabin.cabinLevel, {'active': cabin.checked, 'disabled': cabin.disabled, 'buss': isBussCabin(cabin.cabinLevel), 'ecom': isEcomCabin(cabin.cabinLevel)}]"
                @click="onCabinChange($event, cabin.cabinLevel, cabinIndex, true)"
              >
                <p class="cabin-type">{{cabin.cabinName}}</p>
                <a-checkbox class="cabin-choose" :value="cabin.cabinLevel" :disabled="cabin.disabled" :checked="cabin.checked" @change="onCabinChange($event)" :ref="`cabinCheckBox-${index}`"></a-checkbox>
                <p class="ticket-price" v-if="!cabin.disabled">￥<strong class="pricetag" >{{ cabin.price ? cabin.price : getLowestPrice(cabin) }}</strong>起</p>
                <p class="ticket-price" v-else>-</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
    <div v-if="itineraryType === 'approachFlight' && itinerary.productLoading" class="loading">
      <a-spin></a-spin>
    </div>
    <div v-else :class="['product-list', 'clearfix', isReady ? '' : 'empty']">
      <template v-if="isReady">
        <template v-for="brand in brands">
          <product
            v-show="!brand.isHide"
            :key="brand.products[0].detail.offerItemId"
            :prices="brand.products"
            :itinerary="itinerary"
            :product="brand.products[0]"
            :labelPrices="labelPrices"
            :segment="segment"
            :index="index"
            :checked="brand.checked"
            :isJJC="isJJC"
            :isLC="itinerary.itineraryType === 'CT'"
            @select="onProductSelect"
          >
          </product>
        </template>
      </template>
      <a-spin v-else></a-spin>
    </div>
  </div>
</template>

<script>
import { queryRefundRuleInt } from '@/apis/flight'
import { get, sortBy, uniqBy, xor, compact, some } from 'lodash'
import { setAirlineImage } from '@/assets/js/util'
import Product from './ProductCross'
import '../css/itinerary.less'

const aircraftImageMap = {
  '33C': '/style/8lair/image/aircraft/33E.jpg',
  '33E': '/style/8lair/image/aircraft/33E.jpg',
  '3HH': '/style/8lair/image/aircraft/33E.jpg',
  '330': '/style/8lair/image/aircraft/33E.jpg'
}

export default {
  props: {
    isJJC: Boolean,
    segment: Object,
    itinerary: Object,
    index: Number,
    offerIndex: Number,
    offerItemId: [String, Number],
    labelPrices: Array,
    benefitRules: Array,
    boutiqueAirlineLabels: Array,
    luggageTags: Array,
    isTransfer: Boolean,
    itineraryType: String,
    hasApproachsData: Boolean
  },
  data () {
    return {
      brands: [],
      isReady: false,
      openTransfer: false,
      airline: window.__MICRO_ROOT__?.airline,
      cabinChangeInfo: null
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  created () {
    this.isReady = true
    const { itinerary } = this
    if (this.itineraryType === 'approachFlight') {
      const { cabins } = itinerary
      const selectedCabin = cabins.find(item => { return item.checked === true }) || {}
      this.brands = selectedCabin.brands || []
      this.handleProduct()
    }
  },
  computed: {
    orgDstTotal () {
      const { isTransfer, itinerary } = this
      return isTransfer ? itinerary.orgDstTotal : {}
    }
  },
  methods: {
    setAirlineImage,
    onCabinChange (event, value, index, trigger) {
      event.preventDefault()
      this.cabinChangeInfo = { value: value || event, index, trigger }
      this.handleCabinBrands()
    },
    handleCabinBrands (isRefresh = false, isEmit = true) {
      const { value: val, trigger } = this.cabinChangeInfo
      let value = val

      if (!trigger) {
        value = value.target.value
      }

      const { cabins, orgDsts, tripType } = this.itinerary
      const selectedCabin = cabins.find(item => { return item.cabinLevel === value }) || {}
      const unSelectedCabins = cabins.filter(item => { return item.cabinLevel !== value }) || []
      if (isRefresh && this.hasApproachsData) {
        selectedCabin.checked = false
      }
      selectedCabin.checked = !selectedCabin.checked
      unSelectedCabins.forEach(item => {
        item.checked = false
      })
      this.brands = selectedCabin.checked ? selectedCabin.brands ? selectedCabin.brands : [] : []
      this.handleProduct()

      this.isReady = true
      this.openTransfer = selectedCabin.checked
      if (isEmit) {
        this.$emit('open',
          {
            value,
            index: this.index,
            flightInfo: {
              flightNo: orgDsts[0].flightNo,
              depCode: orgDsts[0].departureCode,
              arrCode: orgDsts[0].arrivalCode,
              tripType
            },
            isSearch: selectedCabin.checked
          }
        )
      }
    },
    handleProduct () {
      this.brands.map(brand => {
        brand.products?.map(product => {
          const services = product.detail.services
          services.forEach(async item => {
            this.formatBenefit(item)
            if (this.ifInternational?.()) {
              const offerItemId = product.detail.offerItemId
              const ruleData = await this.handleQueryRefundRuleInt(offerItemId)
              this.formatRule(item, ruleData)
            }
          })
          return product
        })
        return brand
      })
    },
    onProductSelect (product, choose) {
      const { index } = this
      this.$emit('select', product, choose)
      this.$emit('open', { value: product.detail.offerItemId, index })
    },
    // onRulesChange (index, serviceIndex, rules) {
    //   const { brands } = this
    //   const product = brands.find(item => { return item.index === index })
    //   const currentIndex = brands.findIndex(item => { return item.index === index })
    //   product.detail.services[serviceIndex].changes = rules.change || []
    //   product.detail.services[serviceIndex].refunds = rules.refund || []
    //   product.detail.services[serviceIndex].signeds = rules.signed || []
    //   brands.splice(currentIndex, 1, product)
    // },
    // onBenefitsChange (index, serviceIndex, benefits) {
    //   const { brands } = this
    //   const product = brands.find(item => { return item.index === index })
    //   const currentIndex = brands.findIndex(item => { return item.index === index })
    //   product.detail.services[serviceIndex].benefit.benefits = benefits
    //   product.detail.services[serviceIndex].isBenefit = true
    //   this.formatBenefit(product.detail.services[serviceIndex])
    //   brands.splice(currentIndex, 1, product)
    // },

    // 格式化权益
    formatBenefit (item) {
      if (!item.benefit) return false
      const { benefitRules } = this
      item.benefit.benefits[0].luggageBenefitDetails = []
      let luggageBenefitDetails = []
      item.benefit.benefits[0].languageBenefitDetails?.forEach(element => {
        if (element.passengerType === 'ADULT') {
          for (const key in element) {
            if (key !== 'passengerType' && element[key]) {
              luggageBenefitDetails.push(element[key])
              item.benefit.benefits[0].benefitDetails?.unshift(element[key])
            }
          }
        }
        if (element.checkinBenefit) {
          element.checkinBenefit.passengerType = element.passengerType
          item.benefit.benefits[0].luggageBenefitDetails.push(element.checkinBenefit)
        }
        if (element.carryBenefit) {
          element.carryBenefit.passengerType = element.passengerType
          item.benefit.benefits[0].luggageBenefitDetails.push(element.carryBenefit)
        }
      })
      item.benefit.benefits[0].benefitDetails?.forEach(element => {
        const benefitRule = benefitRules.find(benefitRule => { return benefitRule.code === element?.code }) || {}
        element.icon = benefitRule.icon || 'icon-base-zuanshi'
        element.sort = benefitRule.sort
        element.compoment = benefitRule.compoment || null
        element.template = benefitRule.template || null
      })
      // 去重 & 排序 & 取差集过滤行李权益
      luggageBenefitDetails = compact(luggageBenefitDetails)
      item.benefit.benefits[0].benefitDetails = compact(item.benefit.benefits[0].benefitDetails)
      item.benefit.benefits[0].benefitDetails = uniqBy(item.benefit.benefits[0].benefitDetails, 'code')
      item.benefit.benefits[0].benefitDetails = sortBy(item.benefit.benefits[0].benefitDetails, 'sort')
      item.benefit.benefits[0].benefitDetailsWithoutLuggage = xor(item.benefit.benefits[0].benefitDetails, luggageBenefitDetails)
    },
    // 格式化规则
    formatRule (item, rule) {
      if (!item || !rule) return false
      this.$set(item, 'refundChangeFeesInt', rule)
    },
    exitAircraftImage (value) {
      return aircraftImageMap[value] || ''
    },
    // 是否展示精品航线
    handleShowBoutiqueAirlineByCms (flight) {
      try {
        const { boutiqueAirlineLabels = [] } = this
        if (boutiqueAirlineLabels?.length === 0) {
          return
        }
        const { departureCode, arrivalCode, airlineCode, departureDate } = flight
        const flightCodes = `${departureCode},${arrivalCode}`
        const targetItem = boutiqueAirlineLabels.find(labelItem => {
          const labelCodes = `${labelItem.originCode},${labelItem.destinationCode}`
          const labelAirlineCode = labelItem.airlineCode
          const { labelStartDate, labelEndDate } = labelItem
          const [startDate, endDate, now] = [new Date(labelStartDate)?.getTime(), new Date(labelEndDate)?.getTime(), new Date(departureDate)?.getTime()]
          return airlineCode === labelAirlineCode && // 航司代码条件，支持互售航司打标
                 flightCodes === labelCodes && // 三字码条件
                 ((startDate <= now && now <= endDate) || (startDate <= now && !endDate) || (now <= endDate && !startDate) || (!startDate && !endDate)) // 时间区间条件
        })
        return targetItem
      } catch (error) {
        console.log('error >>>> ', error)
      }
    },
    async handleQueryRefundRuleInt (offerItemId) {
      const { offerIndex } = this
      const params = {
        offerItemId,
        sgmIndex: offerIndex
      }
      try {
        const result = await queryRefundRuleInt(params)
        return result
      } catch (error) {
        return false
      }
    },
    isBussCabin (text) {
      if (!text) {
        return false
      }

      const value = text.toLocaleLowerCase()
      return value.includes('buss')
    },
    getLowestPrice (value) {
      const { airline, ifInternational } = this
      const service = get(value, 'brands[0].products[0].detail.services[0]') ?? {}
      const minFare = (ifInternational?.() && airline === '8L') ? service.defaultFareIncludeTax : service.defaultFare.amount
      return minFare
    },
    isEcomCabin (text) {
      if (!text) {
        return false
      }

      const value = text.toLocaleLowerCase()
      return value.includes('ecom')
    },
    // NOTE: story-view-4489 关于首航新增航线官网展示通程值机标签配置的需求
    getLuggageTags (flight) {
      const { luggageTags: services, airline } = this
      const iataGroupStr = flight.IATAGroup?.join('-')
      const flightNoGroupStr = flight.flightNoGroup?.join('-')
      const transferMinutes = this.getTransferMinutes(flight.transferDuration)
      const departureDate = flight.transferDuration?.departureDate || 'd'
      const arrivalDate = flight.transferDuration?.arrivalDate || 'a'
      // 动态检查是否符合特定条件，并返回相应标签
      for (let service of services) {
        const serviceCodes = service.code?.split(';').map(codeStr => codeStr.trim()).filter(Boolean)
        const isConfigureRoute = some(serviceCodes, codeStr => {
          const [iataCodes, flightNos] = codeStr.split(/[[\]]/).filter(Boolean)
          return iataCodes === iataGroupStr && (!flightNos || flightNos === flightNoGroupStr)
        })
        const isOwner = service.isOwner ? flight.airlineCodeGroup?.every(code => code === airline) : true
        let hasTransferTimeLimit = false
        if (service.min && service.max) {
          hasTransferTimeLimit = transferMinutes >= service.min && transferMinutes <= service.max
        } else if (service.min && !service.max) {
          hasTransferTimeLimit = transferMinutes >= service.min
        } else if (!service.min && service.max) {
          hasTransferTimeLimit = transferMinutes <= service.max
        } else {
          hasTransferTimeLimit = true
        }
        const isSameDay = service.isSameDay ? departureDate === arrivalDate : true
        if (isConfigureRoute && isOwner && hasTransferTimeLimit && isSameDay) {
          return service.tag
        }
      }
      return ''
    },
    getTransferMinutes (transferDuration) {
      const { departureDate, departureTime, arrivalDate, arrivalTime } = transferDuration
      const duration = this.$options.filters.duration({
        departureDate,
        departureTime,
        arrivalDate,
        arrivalTime
      })
      // 转化为分钟
      let totalMinutes = 0
      if (duration) {
        const hourMatch = duration.match(/(\d+)h/)
        const minuteMatch = duration.match(/(\d+)m/)

        const hours = hourMatch ? parseInt(hourMatch[1], 10) : 0
        const minutes = minuteMatch ? parseInt(minuteMatch[1], 10) : 0

        totalMinutes = hours * 60 + minutes
      }
      return totalMinutes
    }
  },
  filters: {
    aircraftImage (value) {
      if (!value) {
        return ''
      }
      return aircraftImageMap[value] || ''
    },
    lowestPrice (value) {
      const minFare = get(value, 'brands[0].products[0].detail.services[0].defaultFare.amount') || ''
      return minFare
    }
  },
  components: {
    Product
  }
}
</script>
